import { render, staticRenderFns } from "./slcustomer.vue?vue&type=template&id=72f5e88c&"
import script from "./slcustomer.vue?vue&type=script&lang=js&"
export * from "./slcustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports